/**
 * <s-product-switcher> wraps a <select> whose option values are sibling product URLs
 * (for example the Ombre, All Black and All White packs of one scent). Choosing an
 * option opens that product's page, so price, stock and the cart line always match.
 */
class SProductSwitcher extends HTMLElement {
  #select = null;

  #onChange = () => {
    const url = this.#select?.value;
    if (url && url !== window.location.pathname) window.location.assign(url);
  };

  connectedCallback() {
    this.#select = this.querySelector('select');
    this.#select?.addEventListener('change', this.#onChange);
  }

  disconnectedCallback() {
    this.#select?.removeEventListener('change', this.#onChange);
    this.#select = null;
  }
}

if (!customElements.get('s-product-switcher')) customElements.define('s-product-switcher', SProductSwitcher);
